<template>
    <v-list>
    <span v-for="(page, i) in nodes" :key="i">
        <v-list-item v-if="page.children.length === 0" :to="page.to" active-class="SelectedTile-active">
           <v-list-item-avatar>
                <v-icon class="white--text">
                    {{ page.icon }}
                </v-icon>
           </v-list-item-avatar>
            <v-list-item-content>

                <v-list-item-title class="white--text">{{ page.name }}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>

        <v-list-group v-else active-class="group-active">
            <template v-slot:activator class="white--text .teste">
                <v-list-item-avatar>
                    <v-icon class="white--text">
                        {{ page.icon }}
                    </v-icon>
                 </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title class="white--text">{{ page.name }}</v-list-item-title>
                </v-list-item-content>
            </template>

            <v-list-item
                v-for="(childPage, i) in page.children"
                :key="i"
                :to="childPage.to"
            >
                <v-list-item-content>
                    <v-list-item-title class="btnChildren">
                          <v-icon class="white--text mr-3">
                                {{ childPage.icon }}
                            </v-icon>
                        {{ childPage.name }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
        </v-list-group>
    </span>
    </v-list>
</template>

<script>
export default {
    name: "menubar",
    data: function () {
        return {
            nodes: [
                {
                    name: "Início",
                    icon: "mdi-home-analytics",
                    children: [],
                    to: "/bemvindo"
                },
                {
                    name: "Dashboard",
                    icon: "mdi-view-dashboard",
                    children: [],
                    to: "/dashboard"
                },
                {
                    name: 'Balanço Energético',
                    icon: "mdi-solar-power-variant-outline",
                    children: [
                        {
                            name: 'Setup',
                            to: "/controle-balanco",
                            icon: "mdi-cog-outline",
                        },
                        {
                            name: 'Visualização',
                            to: "/visualizar-balanco",
                            icon: "mdi-calendar-month-outline",
                        },
                        {
                            name: 'Falhas',
                            to: "/erros-balanco-ano",
                            icon: "mdi-bug-outline",
                        },
                        {
                            name: 'Resultados',
                            to: "/tipos-resultado",
                            icon: "mdi-flag-checkered",
                        },
                        {
                            name: 'Testes de Conformidade',
                            to: "/testes-conformidade",
                            icon: "mdi-text-search",
                        },
                    ],
                },
                {
                    name: 'Unidades Geradoras',
                    icon: "mdi-lightning-bolt-circle",
                    children: [
                        {
                            name: 'Setup',
                            to: "/fazendas-setup",
                            icon: "mdi-flag-checkered",
                        },
                        {
                            name: 'Visualização',
                            to: "/fazendas-ano",
                            icon: "mdi-lightning-bolt-circle",
                        }
                    ]
                },
                {
                    name: 'Balanço Financeiro',
                    icon: "mdi-currency-usd",
                    children: [
                        {
                            name: 'Pré Faturas',
                            to: "/listagem-pre-fatura",
                            icon: "mdi-currency-usd",
                        },
                        {
                            name: 'Descontos Extraordinários',
                            to: "/descontos-extraordinarios",
                            icon: "mdi-gift-outline",
                        },
                        {
                            name: 'Gestão de Faturas',
                            to: "/faturas",
                            icon: "mdi-calendar-month-outline",
                        },
                        {
                            name: 'Falhas',
                            to: "/erros-financeiro",
                            icon: "mdi-bug-outline",
                        },
                    ],
                },
                {
                    name: 'Concessionárias',
                    icon: "mdi-transmission-tower-export",
                    children: [
                        {
                            name: 'Setup',
                            to: "/concessionarias-setup",
                            icon: "mdi-office-building-cog",
                        },
                        {
                            name: 'Grupos Tarifários',
                            to: "/grupos-tarifarios",
                            icon: "mdi-currency-brl",
                        },
                    ],
                },
                {
                    name: "Tradutores",
                    icon: "mdi-translate",
                    children: [
                        {
                            name: "Tradutor",
                            to: "/tradutores",
                            icon: "mdi-translate",
                        },
                        {
                            name: "Painel de Traduções",
                            to: "/tradutores-painel",
                            icon: "mdi-table",
                        }
                    ],
                },
                {
                    name: "Carregar Dados",
                    icon: "mdi-database-import",
                    children: [
                        {
                            name: "Monitoramento de Faturas",
                            to: "/monitoramento-faturas",
                            icon: "mdi-chart-line",
                        },
                        {
                            name: "Carregar Dados",
                            to: "/formulario-faturas-distribuidoras",
                            icon: "mdi-database-import",
                        }
                    ]
                },
                {
                    name: "Relatórios",
                    icon: "mdi-text-box-search",
                    to: "/relatorios",
                    children: []
                },
            ],
        }
    }
}
</script>

<style scoped>
.btnChildren {
    color: #fff;
    margin-left: 35px;
    font-size: 13px;
    font-max-size: 2px;
}
.theme--light  {
    color: #fff !important;
}

.v-list-item:hover {
    background: linear-gradient(135deg, #4b1441, #209a90) !important;
    transform: scale(1.05) !important;
    transition: transform .2s !important;
}

.v-list-item--active {
    background: linear-gradient(135deg, #4b1441, #209a90) !important;
}

.group-active {
    background: linear-gradient(135deg, #4b1441, #209a90) !important;
}

.mdi-chevron-down {
    color: white !important;
}

</style>



// WEBPACK FOOTER //
// src/components/menubar.vue